import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPaginationModule } from "ngx-pagination";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ModalModule, BsModalRef } from "ngx-bootstrap/modal";

import localeFr from "@angular/common/locales/fr";
import { registerLocaleData, CurrencyPipe, DatePipe } from "@angular/common";
import { SharedModule } from "./shared/shared.module";

import { PaginationModule } from "ngx-bootstrap/pagination";
import { JoinTeamComponent } from "./modules/admin/components/setting/join-team/join-team.component";
registerLocaleData(localeFr);

@NgModule({
  declarations: [AppComponent,JoinTeamComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    BrowserAnimationsModule, // required animations module
    NgxPaginationModule,
    ToastrModule.forRoot({ closeButton: true }), // ToastrModule added
    ModalModule.forRoot(),
    SharedModule,
    PaginationModule.forRoot(),
  ],
  providers: [BsModalRef, CurrencyPipe, DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
